const getSpotlightComponent = (state: AnyFixMe) => state.layers.spotlight;

export { getSpotlightComponent };
